<template>
<div class="c-substep step-4-1">
  <div class="c-substep-popup">
    <p>
      Wskaż inne miejsce
    </p>
    <button v-on:click="answer()">Wskaż</button>
    <button class="white" v-on:click="goToMainPage()">Nie, dziękuję</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

export default {
  name: 'step4-1',
  methods: {
    close() {
      this.$store.dispatch('closeSubStep');
    },
    answer() {
      this.$store.dispatch('answer', {
        step: '1',
        answer: '1',
        substep: '4-1',
        asSubstep: true
      })
    },
    goToMainPage() {
      window.location.replace('?end=1');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
